import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _lazy } from '/@/locale';

import styles from './styles.module.css';

@autobind
export default class SoyDensity extends Component {
    static label = _lazy('Densidad');
    static icon = 'density';

    static contextTypes = {
        units: PropTypes.object,
    };

    render() {
        const {
            productRecommendations,
            cropConfig: { crop },
        } = this.props;
        const { units } = this.context;

        const recommendations = productRecommendations
            .filter(({ harvestDensity }) => Boolean(harvestDensity))
            .map(({ harvestDensity: { recommended }, profile: { product } }) => ({
                recommended,
                product,
            }));

        return (
            <div className={styles.root}>
                <div className={styles.header}>
                    <div>{units.getUnit('density', crop)}</div>
                </div>
                {recommendations.map(({ recommended, product }) => (
                    <div key={product.id} className={styles.row}>
                        <div>{product.name}</div>
                        <div>{units.toDensity(recommended, crop).localeValue}</div>
                    </div>
                ))}
            </div>
        );
    }
}
